import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { StorageWallet } from '../../logic/storage';
import TokenPriceHook from '../../hooks/token-price-hook';
import { useQRCodeDownloader } from '../../hooks/use-qr-code-downloader';
import { useBgTelegram } from '../../hooks/useBgTelegram';
import { useTextTelegram } from '../../hooks/useTextTelegram';
import { useBg2Telegram } from '../../hooks/useBg2Telegram';
import { Button } from '../ui/button';
import { Coupon } from '../../logic/coupon';
import { fixAmount } from '../../utils/fix-amount';
import { smlAddr } from '../../utils/sml-addr';
import DOWNLOAD from '../../assets/images/checks/download.svg';
import DONE from '../../assets/images/checks/done.svg';
import SHARE from '../../assets/images/checks/share_outline.svg';
import DELETE from '../../assets/images/checks/delete.svg';
import CANCEL from '../../assets/images/checks/cancel.svg';
import s from './check.module.scss';
export const Check = ({ selectedCheckCard, setSelectedCheckCard, isTestnet, isTg }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [bal, setBal] = useState('0');
    const [info, setInfo] = useState(null);
    const storageWallet = new StorageWallet();
    useEffect(() => {
        const getCheckData = () => {
            try {
                const result = storageWallet.get(selectedCheckCard?.id);
                if (result) {
                    setInfo(result[0]);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        getCheckData();
    }, [selectedCheckCard?.id, setSelectedCheckCard]);
    const handleCancelButtonClick = () => {
        setIsVisible(false);
        setSelectedCheckCard('', '');
        setBal('0');
        setInfo(null);
    };
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (!isVisible) {
            const timer = setTimeout(() => {
                clearTimeout(timer);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isVisible]);
    useEffect(() => {
        const fetchCouponBalance = async () => {
            if (info && info.address) {
                try {
                    const bl = await Coupon.getSumCoupon(info.address, isTestnet);
                    setBal(bl);
                }
                catch (error) {
                    console.error('Error fetching coupon balance:', error);
                }
            }
        };
        if (isVisible && info && selectedCheckCard?.id === info.id) {
            fetchCouponBalance();
        }
    }, [info?.address, selectedCheckCard?.id, isVisible]);
    const handleCopyAddress = () => {
        if (!info) {
            console.error('Something went wrong');
            return;
        }
        if (!info.address) {
            console.error('Something went wrong');
            return;
        }
        const tempTextArea = document.createElement('textarea');
        tempTextArea.value = info.address;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextArea);
        toast.success('Check has been copied to the clipboard');
    };
    const generateQRCodeAndDownload = useQRCodeDownloader(`${window.location.origin}/login?a=${info?.address}` ?? '');
    const handleShareAddress = () => {
        const copyableAddress = `${window.location.origin}/login?a=${info?.address}`;
        navigator.clipboard.writeText(copyableAddress);
        toast.success('Check has been copied to the clipboard');
    };
    const handleDeleteAndRedirect = async () => {
        const shouldDelete = window.confirm('Are you sure you want to delete the coupon?');
        if (!info) {
            console.error('Something went wrong');
            return;
        }
        if (!info.address) {
            console.error('Something went wrong');
            return;
        }
        if (shouldDelete) {
            try {
                const balanceResponse = await Coupon.getSumCoupon(info.address, isTestnet);
                if (balanceResponse) {
                    const balanceData = balanceResponse;
                    const balance = Number(fixAmount(balanceData));
                    if (balance < 0.001) {
                        const deleteSuccessful = storageWallet.del(selectedCheckCard?.id);
                        if (deleteSuccessful) {
                            handleCancelButtonClick();
                            window.location.href = '/';
                        }
                    }
                    else {
                        window.location.href = `${window.location.origin}/login?a=${info?.address}`;
                    }
                }
                else {
                    window.location.href = `${window.location.origin}/login?a=${info?.address}`;
                }
            }
            catch (error) {
                window.location.href = `${window.location.origin}/login?a=${info?.address}`;
            }
        }
    };
    const [styleBtn, setStyleBtn] = useState({});
    useEffect(() => {
        if (isTg) {
            setStyleBtn({
                backgroundColor: 'var(--tg-theme-button-color)',
                color: 'var(--tg-theme-button-text-color)',
                important: 'true'
            });
        }
        else {
            setStyleBtn({});
        }
    }, [isTg]);
    const telegramBG = useBgTelegram(isTg);
    const telegramBG2 = useBg2Telegram(isTg);
    const telegramText = useTextTelegram(isTg);
    return (_jsxs("div", { className: s.checkBody, children: [isVisible && _jsx("div", { className: s.overlay }), _jsx("div", { className: `${s.check} ${isVisible ? s.slideIn : s.slideOut}`, children: _jsx("div", { className: s.checkInner, children: _jsxs("div", { className: `container ${s.container}`, style: telegramBG, children: [_jsxs("div", { className: s.headerTop, children: [_jsx("h1", { className: s.headerTitle, style: telegramText, children: "Check" }), _jsx(Button, { variant: "small-button", startIcon: CANCEL, onClick: handleCancelButtonClick, style: styleBtn, isTg: isTg })] }), _jsxs("div", { className: s.checkInfo, style: telegramBG, children: [_jsxs("div", { className: s.item, children: [_jsx("div", { className: s.title, style: telegramText, children: "Status:" }), _jsx("div", { className: s.description, style: telegramText, children: Number(fixAmount(bal)) > 0.001 ? 'Not activated' : 'Activated' })] }), _jsxs("div", { className: s.item, children: [_jsx("div", { className: s.title, style: telegramText, children: "Address:" }), _jsx("div", { className: s.descriptionAddress, onClick: handleCopyAddress, style: telegramText, children: smlAddr(info?.address) })] }), _jsxs("div", { className: s.item, children: [_jsx("div", { className: s.title, style: telegramText, children: "Sum:" }), _jsxs("div", { className: s.description, style: telegramText, children: [fixAmount(bal), " TON (", _jsx(TokenPriceHook, { tokenAmount: Number(fixAmount(bal)) }), ")"] })] }), _jsxs("div", { className: s.item, children: [_jsx("div", { className: s.title, style: telegramText, children: "Password:" }), _jsx("div", { className: s.status, children: _jsx("img", { src: DONE, alt: "Done" }) })] }), _jsxs("div", { className: s.itemAction, children: [_jsx("div", { className: s.titleDownload, style: telegramText, children: "Download:" }), _jsx("div", { children: _jsxs("button", { className: s.itemDownload, onClick: generateQRCodeAndDownload, style: styleBtn, children: ["Download", _jsx("img", { src: DOWNLOAD, alt: "Download" })] }) })] }), _jsxs("div", { className: s.checkActions, children: [_jsx(Button, { variant: "action-button", startIcon: SHARE, onClick: handleShareAddress, style: styleBtn, isTg: isTg, children: "Share" }), _jsx(Button, { variant: "action-button", startIcon: DELETE, onClick: handleDeleteAndRedirect, style: styleBtn, isTg: isTg, children: "Delete" })] })] })] }) }) })] }));
};
